import Logo from "assets/images/sandbox.svg";
import drawerLogoRight from "assets/images/menu_right_arrow.svg";
import drawerLogoLeft from "assets/images/menu_left_arrow.svg";
import Poweredby from "assets/images/company-logo.png";
import favicon from "assets/images/favicon.png";

const Initial = {
  branding: {
    favicon:favicon,
    logo: Logo,
    poweredbylogo: Poweredby,
  },
  organization:{
    name:"ZVAF",
    title:"Zenith Ventures",
    description:"Home | Zenith Ventures",
  },
  flow: {
    logiFlow1:true,
    logiFlow2:true,
    registerFlow1:true,
    registerFlow2:false,
  },
  theme: {
    textColor: "#333333",
    mainColor:"#3538cd",    //set the header color of the table 
    darkColor:"#3538cd"
  },
  sidebar: {
    // investor menuList
    all_investors:true,
    lead_investors:true,
    syndicate:true,
    soa:true,

    // startup menuList
    deals:true,
    selected:true,
    applications:true,

    // bank
    bank:true,

    // documents
    documents:true,

    // reports menuList
    live_deal_summary:true,
    missing_investor_data:true,
    investor_onboarding_summary:true,
    deal_document_checklist:true,
    startup_document_checklist:true,

    // users menuList
    users:true,
    role:true,

    // settings menuList
    lists:true,
    checklists:true,

    // content menuList
    articles:true,
    feedbacks:true,
    logoRight: drawerLogoRight,
    logoLeft: drawerLogoLeft,
  },
  dashboard:{
    fund_summary:true,
    deal_inprogress_summary:true,
  },
  investor:{
    send_onboarding_doc:true,
    send_soa:true,
    generate_agreements:true,
  },
  startup:{
    view_deals_progressbar:true,
    view_deals_settings:true,
    edit_deals_generate_documents:true,
  },
  settings:{
    lists_message:true,
  }
};

// Inject CSS variables directly into the document head
const setCSSVariables = () => {
  const style = document.createElement("style");
  style.innerHTML = `
    :root {
      --text-color: ${Initial.theme.textColor};
      --main-color: ${Initial.theme.mainColor};
      --dark-color: ${Initial.theme.darkColor};
      --background-color: ${Initial.theme.backgroundColor};
    }
  `;
  document.head.appendChild(style);
};

// Call the function to apply styles
setCSSVariables();
window.Initial = Initial;

export default Initial;
